import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ActividadesLogroObjetivosDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ActividadesLogroObjetivosService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private readonly http: HttpClient) {}

  getActividadesLogroObjetivosService(): Observable<
    BodyListResponse<ActividadesLogroObjetivosDTO>
  > {
    return this.http.get<BodyListResponse<ActividadesLogroObjetivosDTO>>(
      API_URL + '/api/v1/actividadesLogroObjetivos/todos',
    );
  }

  guardarActividadesLogroObjetivosService(
    actividadesLogroObjetivosDTO: ActividadesLogroObjetivosDTO,
  ): Observable<BodyResponse<ActividadesLogroObjetivosDTO>> {
    return this.http.post<BodyResponse<ActividadesLogroObjetivosDTO>>(
      API_URL + '/api/v1/actividadesLogroObjetivos',
      actividadesLogroObjetivosDTO,
    );
  }

  getActividadesLogroObjetivosPorCodigoService(
    codigo: string,
  ): Observable<BodyResponse<ActividadesLogroObjetivosDTO>> {
    return this.http.get<BodyResponse<ActividadesLogroObjetivosDTO>>(
      API_URL + '/api/v1/actividadesLogroObjetivos/' + codigo,
    );
  }
}
